module.exports = __webpack_public_path__ + "static/media/Copy of Copy of IMG_2115_Original 1.277a9f7f.jpg";